import React, { useEffect, useState, Fragment } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  FormFeedback,
  Form,
  Input,
  ButtonDropdown,
  DropdownMenu,
  DropdownItem,
  DropdownToggle,
  Container
} from "reactstrap";
import { map } from "lodash";
import AlertSuccess from "../../components/Alerts/AlertSuccess";
import Select from "react-select";
import Breadcrumbs from "/src/components/Common/Breadcrumb";
import CardCostCenter from "./CardCostCenter";
import { getCostCentersAdmin, getOrgsAdmin } from "../../helpers/api_rombo_helper";
import { useSelector, useDispatch } from "react-redux";
import { createSelector } from "reselect";
import DeleteCostCenterModal from "./DeleteCostCenterModal";
import DownloadReportsModal from "./DownloadReportsModal";
import i18n from "../../i18n";
import * as Yup from "yup";
import { useFormik } from "formik";
import PaginationV2 from "../../components/Pagination/PaginationV2";
import Spinners from "../../components/Common/Spinner";
import { orgId } from "../../constants/utils";
import { Permissions } from "../../constants/enums";

const CostCenters = () => {

  const dispatch = useDispatch()

  const [newCostCenterModal, setNewCostCenterModal] = useState(false);
  const toggleViewModal = () => setNewCostCenterModal(!newCostCenterModal);
  const [deleteCostCenterModal, setDeleteCostCenterModal] = useState(false);
  const [nameNewCostCenter, setNameNewCostCenter] = useState(null);
  const [opts, setOpts] = useState({});
  const [checkCostCenter, setCheckCostCenter] = useState([]);

  const [downloadReportsModal, setDownloadReportsModal] = useState(false);
  const [showAlertSuccess, setShowAlertSuccess] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [textHeader, setTextHeader] = useState('');
  const [textBody, setTextBody] = useState('');
  const [infoUser, setInfoUser] = useState({ permissions: [] });
  const [fCompany, setFCompany] = useState(() => {
    const stored = localStorage.getItem("selectedCompany");
    return stored ? Number(stored) : null;
  });  

  const [isLoading, setLoading] = useState(true);
  const [drp_link, setDrp_link] = useState(false);
  const [reloadCostCenter, setReloadCostCenter] = useState(false);
  const [costCenters, setCostCenters] = useState({});
  const [findCostCenters, setFindCostCenters] = useState([]);
  const [listCompanies, setListCompanies] = useState([]);
  const [showCheckboxes, setShowCheckboxes] = useState(false);

  const LoginProperties = createSelector(
    (state) => state.Login,
    (Login) => ({
      token: Login.token,
      loading: Login.loading,
      data: Login.data
    })
  );

  const { token, data, loading } = useSelector(LoginProperties);

  useEffect(() => {
    document.title = `${i18n.t("CostCenter")} - ${orgId}`;
  }, [orgId]);

  useEffect(() => {
    if (fCompany) {
      localStorage.setItem("selectedCompany", fCompany.toString());
    } else {
      localStorage.removeItem("selectedCompany");
    }
  }, [fCompany]);  

  useEffect(() => {
    if(localStorage.getItem("notify") == "true"){
      setShowAlertSuccess(true)
      setTextHeader(localStorage.getItem("headerText"));
      setTextBody(localStorage.getItem("bodyText"));
      localStorage.setItem("notify", "false");
    }
    onGetCostCentersAdmin(opts);
    setReloadCostCenter(false);
    if(infoUser.is_staff) onGetOrgsAdmin();
  }, [dispatch, reloadCostCenter, loading]);

  useEffect(() => {
    if(infoUser.is_staff) onGetOrgsAdmin();
  }, [infoUser]);
  
  useEffect(() => {
    if(data?.data){
      setInfoUser(data.data)
    }
  }, [data, loading]);
  
  useEffect(() => {
    if (fCompany) {
      onGetCostCentersAdmin({ ...opts, partner_id: fCompany });
    } else {
      onGetCostCentersAdmin();
    }
  }, [fCompany]);

  useEffect(() => {
    if (checkCostCenter.length > 0) {
      setErrorMessage("");
    }
  }, [checkCostCenter]);

  const autoformik = useFormik({
    initialValues: {
      search: "",
      members: "",
      services: ""
    },
    validationSchema: Yup.object({
      search: Yup.string(),
      members: Yup.string(),
      services: Yup.string()
    })
  });

  const onGetCostCentersAdmin = (newOpts = { page: 1, size: 12 }) => {
    if (token.Authorization) {
      const options = { ...newOpts, ...(fCompany && { partner_id: fCompany }) };
      getCostCentersAdmin(token, options)
        .then((response) => {
          setOpts(options);
          setLoading(false);
          setCostCenters(response);
          setFindCostCenters(response.items);
        })
        .catch((error) => {
          console.error("Error - getCostCentersAdmin - ", error);
        });
    }
  };

  const onChangePagePaginate = (page) => {
    var newOpts = {
      name: autoformik.values.search || null,
      members: autoformik.values.members || null,
      services: autoformik.values.services || null,
      partner_id: fCompany || null,
      page: page,
      size: 12
    }
    onGetCostCentersAdmin(newOpts);
  };

  const onGetOrgsAdmin = () => {
    let arr = []
    getOrgsAdmin(token)
      .then((response) => {
        response.map((item) => {
          arr.push({ label: item.name, value: item.partner_id })
        })
        setListCompanies([...arr])
      })
      .catch((error) => {
        console.error("Error - onGetOrgsAdmin - ", error);
        setErrorAlert(true);
        setErrorAlertMessage((error?.response?.data?.detail || error.message))
      })
  };

  const searchFilters = (value, type) => {
    setFindCostCenters([])
    var newOpts = {
      name: type == "name" ? (value || "") : (autoformik.values.search || ""),
      members: type == "members" ? (value) : (autoformik.values.members || null),
      services: type == "services" ? (value) : (autoformik.values.services || 0),
      partner_id: fCompany || null,
      page: 1,
      size: 12
    }
    onGetCostCentersAdmin(newOpts);
  };

  const toggleViewModalDelete = () => {
    if (!showCheckboxes) {
      setShowCheckboxes(true);
      setErrorMessage("");
    } else if (checkCostCenter.length > 0) {
      setDeleteCostCenterModal(!deleteCostCenterModal);
      setErrorMessage("");
    } else {
      setErrorMessage(i18n.t("SelectAtLeastOneCostCenter"));
    }
  };
  
  const toggleViewModalDownloadReport = () => {
    if (!showCheckboxes) {
      setShowCheckboxes(true);
      setErrorMessage("");
    } else if (checkCostCenter.length > 0) {
      setDownloadReportsModal(!downloadReportsModal);
      setErrorMessage("");
    } else {
      setErrorMessage(i18n.t("SelectAtLeastOneCostCenter"));
    }
  };  

  return (
    <Fragment>
      <div className="page-content">
        <Breadcrumbs title={i18n.t("CostCenter")} breadcrumbItem={i18n.t("CostCenter")} />
        <Card>
          <CardBody className="pb-2">
            <Row className="pb-2">
              <Col xs={12} xl={12} md={12} className="pb-2">
                <Row>
                  <Col xxl={9} md={7} xs={12}>
                    <CardTitle className="h4">{i18n.t("CostCenter")}</CardTitle>
                    {(!fCompany && !infoUser?.partner_id) || errorMessage ? (
                      <span className="error-message-requests">
                        <i className="fa fa-exclamation-circle"></i>
                        {errorMessage || i18n.t("SelectAPartnerToViewCostCenter")}
                      </span>
                    ) : null}
                  </Col>
                  <Col xxl={12} className="d-flex justify-content-end align-items-start mb-4">
                    <Row>
                      <Col xxl={8} md={8} xs={8}>
                        {infoUser.permissions.includes(Permissions.COST_CENTER_CREATE) && (
                          <Link to={`/cost-centers/new`} className="btn btn-request">
                            {i18n.t("NewCostCenter")}
                          </Link>
                        )}
                      </Col>
                      <Col xxl={2} md={2} xs={4}>
                        <ButtonDropdown isOpen={drp_link} toggle={() => { setDrp_link(!drp_link) }}>
                          <DropdownToggle className="btn btn-employees-options button-margin-minleft px-3" caret color="secondary">
                            ⋮
                          </DropdownToggle>
                          <DropdownMenu className="custom-dropdown-menu">
                              <DeleteCostCenterModal
                                token={token}
                                setReloadCostCenter={setReloadCostCenter}
                                reloadCostCenter={reloadCostCenter}
                                checkCostCenter={checkCostCenter}
                                setCheckCostCenter={setCheckCostCenter}
                                setShowAlertSuccess={setShowAlertSuccess}
                                isOpen={deleteCostCenterModal}
                                toggle={toggleViewModalDelete}
                                setDeleteCostCenterModal={setDeleteCostCenterModal}
                                setTextHeader={setTextHeader}
                                setTextBody={setTextBody}
                              />
                              {infoUser.permissions.includes(Permissions.COST_CENTER_DELETE) && (
                                <DropdownItem onClick={toggleViewModalDelete}>
                                  {i18n.t("DeleteCostCenter")}
                                </DropdownItem>
                              )}
                              <DownloadReportsModal
                                token={token}
                                setDownloadReportsModal={setDownloadReportsModal}
                                isOpen={downloadReportsModal}
                                toggle={toggleViewModalDownloadReport}
                                setShowAlertSuccess={setShowAlertSuccess}
                                checkCostCenter={checkCostCenter}
                                setTextHeader={setTextHeader}
                                setTextBody={setTextBody}
                              />
                              <DropdownItem onClick={toggleViewModalDownloadReport}>
                                {i18n.t("DownloadReportCostCenter")}
                              </DropdownItem>
                          </DropdownMenu>
                        </ButtonDropdown>
                      </Col>
                    </Row>
                  </Col>
                </Row>
              </Col>
              {infoUser.is_staff && (
              <Col xxl={2} md={2} xs={12} className="">
                <Card className="mb-0">
                  <Select
                    name="company"
                    placeholder={i18n.t("Partner")}
                    options={listCompanies}
                    isClearable
                    className="select2-selection"
                    value={listCompanies.find(({ value }) => value === fCompany) ?? null} 
                    onChange={(e) => {
                      setFCompany(e?.value || null); 
                    }}
                  />
                </Card>
              </Col>
              )}
              <Col xs={12} xl={12} md={6} className="pb-2">
              <div className="orange-separator" />
                <Form className="row gy-2 gx-3 align-items-center" onSubmit={autoformik.handleSubmit}>
                  <Col xxl={4} md={4} xs={12}>
                    <div className="">
                      <Input
                        type="text"
                        name="search"
                        className="form-control"
                        id="searchInput"
                        placeholder={i18n.t("SearchName")}
                        value={autoformik.values.search}
                        onBlur={(e) => autoformik.handleBlur(e)}
                        onChange={(e) => {
                          autoformik.handleChange(e);
                          searchFilters(e.target.value, "name");
                        }}
                        invalid={
                          autoformik.touched.search && autoformik.errors.search ? true : false
                        }
                      />
                      {autoformik.errors.search && autoformik.touched.search && (
                        <FormFeedback type="invalid">
                          {autoformik.errors.search}
                        </FormFeedback>
                      )}
                    </div>
                  </Col>
                  <Col xxl={2} md={2} xs={12}>
                    <div className="">
                      <Input
                        type="text"
                        name="members"
                        className="form-control"
                        id="membersInput"
                        placeholder={i18n.t("Members")}
                        value={autoformik.values.members}
                        onBlur={(e) => autoformik.handleBlur(e)}
                        onChange={(e) => {
                          autoformik.handleChange(e);
                          searchFilters(e.target.value, "members");
                        }}
                        invalid={
                          autoformik.touched.members && autoformik.errors.members ? true : false
                        }
                      />
                      {autoformik.errors.members && autoformik.touched.members && (
                        <FormFeedback type="invalid">
                          {autoformik.errors.members}
                        </FormFeedback>
                      )}
                    </div>
                  </Col>
                  <Col xxl={2} md={2} xs={12}>
                    <div className="">
                      <Input
                        type="text"
                        name="services"
                        className="form-control"
                        id="servicesInput"
                        placeholder={i18n.t("Services")}
                        value={autoformik.values.services}
                        onBlur={(e) => autoformik.handleBlur(e)}
                        onChange={(e) => {
                          autoformik.handleChange(e);
                          searchFilters(e.target.value, "services")
                        }}
                        invalid={
                          autoformik.touched.services && autoformik.errors.services ? true : false
                        }
                      />
                      {autoformik.errors.services && autoformik.touched.services && (
                        <FormFeedback type="invalid">
                          {autoformik.errors.services}
                        </FormFeedback>
                      )}
                    </div>
                  </Col>
                </Form>
              </Col>
            </Row>
          </CardBody>
        </Card>
        <Container fluid>
          {isLoading ? null : (
            <>
              {!fCompany && !infoUser?.partner_id ? (
                <div className="text-center mt-5">
                  <i className="bx bx-list-ul icon-no-results"></i>
                </div>
              ) : (
                <Row>
                  {map(findCostCenters, (costCenter, key) => (
                    <CardCostCenter
                      costCenter={costCenter}
                      checkCostCenter={checkCostCenter}
                      setCheckCostCenter={setCheckCostCenter}
                      key={"_shop_" + key}
                      showCheckboxes={showCheckboxes}
                    />
                  ))}
                  {isLoading ? (
                    <Spinners setLoading={setLoading} />
                  ) : (
                    <PaginationV2
                      currentPage={costCenters.page}
                      pageSize={costCenters.size}
                      totalItems={costCenters.total}
                      onChangePage={onChangePagePaginate}
                    />
                  )}
                </Row>
              )}
            </>
          )}
        </Container>
        <AlertSuccess
          showAlertSuccess={showAlertSuccess}
          setShowAlertSuccess={setShowAlertSuccess}
          textHeader={textHeader}
          textBody={textBody}
        />
      </div>
    </Fragment>
  )
}

CostCenters.propTypes = {
  onGetCostCenters: PropTypes.func
}

export default CostCenters;
